import HalfProficiencyIcon from './HalfProficiencyIcon';
import NoProficiencyIcon from './NoProficiencyIcon';
import ProficiencyIcon from './ProficiencyIcon';
import ProficiencyLevelIcon from './ProficiencyLevelIcon';
import TwiceProficiencyIcon from './TwiceProficiencyIcon';

export default ProficiencyLevelIcon;
export { ProficiencyLevelIcon, NoProficiencyIcon, ProficiencyIcon, HalfProficiencyIcon, TwiceProficiencyIcon };
